module.exports = __webpack_public_path__ + "img/T7S game preview 2.027426e2.webp";